module.exports = __webpack_public_path__ + "fonts_/iconfont.c27c4ff.eot";


//////////////////
// WEBPACK FOOTER
// ./src/font/iconfont.eot?t=1573030555456
// module id = 6
// module chunks = 0